export default __webpack_public_path__ + "static/media/coin.a0c1eeb3.svg";